import '@/vendor/jplayer/jquery.jplayer.js';
import $ from 'jquery';
import tectoastr from '@/lib/tectoastr';

/**
 * Audio player - setup jPlayer for mp3 playback.
 *
 * http://jplayer.org/
 */
export default class Audio {
	constructor() {
		this.player = null;
		this.container = null;
		this.playing = false;
		this.debug = false;
		this.swfPath = '/vendor/jplayer';
	}

	attachLauncher(element) {
		const button = $(element).next('.jp-audio-stream').find('.jp-play');

		button.on('click', (event) => {
			event.preventDefault();

			// player is already launched, nothing to do
			if ($(element).data('id') === $(this.player).data('id')) return;

			if (this.playing) {
				this.disableTimer();
				$(this.player).jPlayer('destroy').off();
			}

			this.initJPlayer(element);
			this.enableErrorHandling();
			this.enableTimer();

			this.playing = true;
		});
	}

	initJPlayer(element) {
		this.player = element;
		this.container = `#jp-container-${$(element).data('id')}`;

		$(element).jPlayer({
			ready: () => {
				this.playMedia();
			},
			swfPath: this.swfPath,
			cssSelectorAncestor: this.container,
			supplied: $(this.player).data('format'),
			wmode: 'window',
			useStateClassSkin: true,
			smoothPlayBar: true,
			errorAlerts: this.debug,
			warningAlerts: this.debug,
		});
	}

	playMedia() {
		const media = {};
		media[$(this.player).data('format')] = $(this.player).data('url');
		$(this.player).jPlayer('setMedia', media).jPlayer('play');
	}

	enableTimer() {
		$(this.player).on($.jPlayer.event.play, () => {
			$(this.container).find('.jp-timer').removeClass('hidden');
		});

		$(this.player).on($.jPlayer.event.pause, () => {
			$(this.container).find('.jp-timer').removeClass('hidden');
		});

		$(this.player).on($.jPlayer.event.ended, () => {
			$(this.container).find('.jp-timer').addClass('hidden');
		});
	}

	disableTimer() {
		$(this.container).find('.jp-timer').addClass('hidden');
	}

	enableErrorHandling() {
		$(this.player).on($.jPlayer.event.error, (event) => {
			tectoastr.error(event.jPlayer.error.message);
		});
	}

	controlAudio(preview) {
		$(preview).on('click', (event) => {
			event.preventDefault();
			$(event.currentTarget).next('.jp-jplayer').next('.jp-audio-stream').find('.jp-play').trigger('click');
		});
	}

	setup(elements) {
		elements = $('.' + elements);

		elements.each((index, el) => {
			this.attachLauncher(el);
		});

		this.controlAudio('.preview-container.audio');
	}
}
